import { constants as config } from '@config';

const TextSetter = require('../setters/text');

const ElementCreator = require('./abstract/element');

module.exports = TextCreator;

// We should probably mix INKIVE.Text.Textarea here
function TextCreator () {}
TextCreator.prototype = new ElementCreator();
TextCreator.prototype.constructor = TextCreator;

TextCreator.prototype.initialize = function () {
  ElementCreator.prototype.initialize.call(this);

  this.mandatory = ['text'];
  _.extend(this.defaults, {
    content: null,
    font: {
      family: 'Nunito',
      size: '21',
      weight: null,
      style: null
    },
    smart_asset: null,
    decoration: null,
    heading: null
  });
};

TextCreator.prototype.create = function (data) {
  const addData = this.getAddData(data);

  if (data.smart_asset) {
    addData[config.smartAssets.attributes.definedAsset] = data.smart_asset;
    addData.definedContentType = config.smartAssets.typeToProperty.texts;
  }

  if (data.meta) addData.meta = data.meta;

  const element = this.canvas.addElement('textarea', addData);

  TextSetter.prototype._processFontFamily.call(this, element, {
    family: addData.text.font_family
  });

  this.trigger('', element.getAttribute('id'), data);

  (typeof data.selected === 'undefined' || data.selected) &&
    this.canvas.selectOnly([element]);

  return element.getAttribute('id');
};

TextCreator.prototype.getAddData = function (data) {
  const getDefinedData = _.bind(this.getDefinedData, this, data);

  return {
    library_text: data.library_text || false,
    x: getDefinedData('position.x'),
    y: getDefinedData('position.y'),
    width: getDefinedData('size.width'),
    smart_asset: getDefinedData('smart_asset'),
    heading: getDefinedData('heading'),
    text: {
      font_size: getDefinedData('font.size'),
      font_family: getDefinedData('font.family'),
      font_weight: getDefinedData('font.weight'),
      font_style: getDefinedData('font.style'),
      text_decoration: getDefinedData('decoration'),
      textContent: getDefinedData('content')
    }
  };
};
